import { render, staticRenderFns } from "./MarketApproveSettingHistory.vue?vue&type=template&id=5da97832"
import script from "./MarketApproveSettingHistory.vue?vue&type=script&lang=js"
export * from "./MarketApproveSettingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports